import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AlertPopupComponent, AlertButton, AlertPopupData } from '../components/shared/alert-popup/alert-popup.component';

export interface AlertPopupOptions {
  title?: string;
  darkTheme?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PopupService {

  constructor(private dialog: MatDialog) { }

  openPopup(
    component: any,
    message: string,
    type: any,
    width: any,
    buttonLabel?: string,
    showCancelButton?: boolean,
    cancelButtonLabel?: string
  ): MatDialogRef<any> {
    const dialogConfig: MatDialogConfig = {
      width: width,
      backdropClass: 'blurred',
      disableClose: true,
      data: { message, type, buttonLabel, showCancelButton, cancelButtonLabel }
    };

    return this.dialog.open(component, dialogConfig); // Return MatDialogRef
  }

  /**
   * Open a generic alert popup with success, error, or warning styling
   * @param message The message to display
   * @param type The type of alert: 'success', 'error', or 'warning'
   * @param buttons Optional custom buttons (defaults to OK button)
   * @param width Optional width (defaults to '40%')
   */
  openAlert(
    message: string,
    type: 'success' | 'error' | 'warning',
    buttons?: AlertButton[],
    width: string = '40%',
    options?: AlertPopupOptions
  ): MatDialogRef<AlertPopupComponent> {
    const dialogConfig: MatDialogConfig<AlertPopupData> = {
      width: width,
      backdropClass: 'blurred',
      disableClose: true,
      panelClass: options?.darkTheme ? 'alert-popup-dialog--dark' : undefined,
      data: { message, type, buttons, ...options }
    };

    return this.dialog.open(AlertPopupComponent, dialogConfig);
  }
}
